import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { ResetComponent } from './reset/reset.component';
import { ForgetComponent } from './forget/forget.component';
import { SetpasswordComponent } from './setpassword/setpassword.component';
import { ChangepasswordComponent } from './changePassword/changepassword.component';
import { LayoutComponent } from './layout/layout.component';
import { SignupComponent } from './signup/signup.component';
import { ExistingAccountComponent } from './existing-account/existing-account.component';
import { NewBusinessComponent } from './new-business/new-business.component';

const routes: Routes = [
  {
      path: '', component: LayoutComponent,
      children: [
          { path: 'login', component: LoginComponent },
          { path: 'resetPassword', component: ResetComponent },
          { path: 'forgetPassword', component: ForgetComponent },
          { path: 'setPassword', component: SetpasswordComponent },
          { path: 'changePassword', component: ChangepasswordComponent },
          { path: 'signup', component: SignupComponent },
          { path: 'existingaccount', component: ExistingAccountComponent },
          { path: 'newbusiness', component: NewBusinessComponent },
      ]
  }
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }